<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title>Browser Sessions</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <div class="text--primary">
        If necessary, you may logout of all of your other browser sessions
        across all of your devices. Some of your recent sessions are listed
        below; however, this list may not be exhaustive. If you feel your
        account has been compromised, you should also update your password.
      </div>
    </v-card-text>
    <v-card-text>
      <v-list two-line>
        <template v-for="(session, key) in sessions">
          <v-list-item :key="`session_${key}`">
            <v-list-item-avatar
              :rounded="0"
            >
              <svg
                v-if="session.agent.is_desktop"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="w-8 h-8 text-gray-500"
              >
                <path
                  d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="w-8 h-8 text-gray-500"
              >
                <path d="M0 0h24v24H0z" stroke="none" />
                <rect x="7" y="4" width="10" height="16" rx="1" />
                <path d="M11 5h2M12 17v.01" />
              </svg>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ session.agent.platform }} -
                {{ session.agent.browser }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ session.ip_address }},
                <span
                  v-if="session.is_current_device"
                  class="text-green-500 font-semibold"
                >This device</span>
                <span
                  v-else
                >Last active {{ session.last_active }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <confirm-logout-sessions>
        Logout Other Browser Sessions
      </confirm-logout-sessions>
    </v-card-actions>
  </v-card>
</template>

<script>
import ConfirmLogoutSessions from '@/Components/Profile/ConfirmLogoutSessions.vue'

export default {
   components: { ConfirmLogoutSessions },
   props: {
      sessions: {
         type: Array,
         required: true
      },
   },
}
</script>

<style>
</style>
